<template>
  <div class="subgroup-select position-relative">
    <!-- Trigger (what user clicks to open dropdown) -->
    <div
      :class="routerPage ? 'border-contribution-small' : 'border-contribution'"
      class="d-flex justify-content-between align-items-center"
      @click="toggleDropdown"
    >
      <span>
        <span v-if="modelValue.length > 0 && modelValue.length <= 3">
          <el-tag
            v-for="item in modelValue"
            :key="item.id"
            type="info"
            class="mr-1"
          >
            {{ item.name }}
          </el-tag>
        </span>
        <span v-if="modelValue.length > 0 && modelValue.length > 3">
          <el-tag
            v-for="item in modelValue.slice(0, 3)"
            :key="item.id"
            type="info"
            class="mr-1"
          >
            {{ item.name }} ...
          </el-tag>
        </span>
        <span v-if="modelValue.length === 0">
          {{ placeholder }}
        </span>
      </span>
      <el-icon class="el-icon--right pr-1">
        <arrow-down />
      </el-icon>
    </div>

    <!-- Dropdown -->
    <transition name="fade">
      <div
        v-if="open"
        class="div-card p-2 mt-1 position-absolute bg-white shadow rounded w-100"
        v-click-outside="closeDropdown"
      >
        <el-icon class="is-loading mb-2" v-if="loading && items.length === 0">
          <Loading />
        </el-icon>

        <el-input
          type="text"
          class="w-100 mb-2"
          v-model="searchText"
          ref="searchGroupRef"
          placeholder="Search for group"
        />

        <GroupTreeCheckboxParent
          :items="filteredItems"
          :addGroupValue="true"
          @filteredGroup="emitFilterGroups"
          @newgroup="emitNewGroup"
          @select="selectGroup"
        />
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watch } from "vue";
import GroupTreeCheckboxParent from "./GroupTreeCheckboxParent.vue";
import { useRoute } from "vue-router";

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  placeholder: { type: String, default: "Select group" },
});

const emit = defineEmits(["update:modelValue", "filteredGroup", "newgroup"]);
const routerPage = ref("");

const open = ref(false);
const searchText = ref("");
const searchGroupRef = ref(null);
const route = useRoute();
const checkRoute = () => {
  routerPage.value =
    route.fullPath.includes("/tenant/reports/financialofferingreport") ||
    route.fullPath.includes("/tenant/reports/financialpledgesreport") ||
    route.fullPath.includes("/tenant/reports/attendancereport") ||
    route.fullPath.includes("/tenant/pledge/pledgeslist") ||
    route.fullPath.includes("/tenant/branchreports/offeringreport") ||
    route.fullPath.includes("/tenant/branchreports/checkinattendancereport") ||
    route.fullPath.includes("/tenant/reports/offeringfinancialreport");
};

// Watch for route changes
watch(
  () => route.fullPath,
  () => {
    checkRoute();
  },
  { immediate: true }
);

const filteredItems = computed(() => {
  if (!searchText.value) return props.items;
  return props.items.filter((g) =>
    g.name.toLowerCase().includes(searchText.value.toLowerCase())
  );
});

const toggleDropdown = () => {
  open.value = !open.value;
  if (open.value) {
    nextTick(() => {
      searchGroupRef.value?.focus();
    });
  }
};

const closeDropdown = () => {
  open.value = false;
};

const selectGroup = (group) => {
  emit("update:modelValue", [group]); // or multiple
  closeDropdown();
};

const emitFilterGroups = (groups) => {
  emit("filteredGroup", groups);
};

const emitNewGroup = (group) => {
  emit("newgroup", group);
  closeDropdown();
};
</script>
<script>
import clickOutside from "@/directives/clickOutside";

export default {
  directives: {
    clickOutside,
  },
};
</script>

<style scoped>
.subgroup-select {
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.div-card {
  position: absolute;
  background: white;
  z-index: 1;
  width: 100%;
  max-height: 400px;
  overflow: scroll;
}
</style>
